import * as Sentry from '@sentry/react';
import { atom } from 'jotai';
import { homeDefaultTeamAtom } from './defaultTeam';
import { homeDefaultTeamCompetitionAtom } from './defaultTeamCompetition';
import { homeNextGameAtom } from './nextGame';
import { homeLatestPlayerSearchAtom } from './savedSearch';

// A card that can be left out reports its failure and is dropped, so one failed lookup never costs the section.
const reportedOrNull = async <T>(lookup: Promise<T>): Promise<T | null> => {
  try {
    return await lookup;
  } catch (error) {
    Sentry.captureException(error);
    return null;
  }
};

// Every lookup starts together and Quick Start renders once they have all settled, so the row appears complete
// (design D3). The default team is what the section is about, so its failure is left to the section's error boundary.
export const homeQuickStartAtom = atom(async get => {
  const [defaultTeam, competition, nextGame, savedSearch] = await Promise.all([
    get(homeDefaultTeamAtom),
    reportedOrNull(get(homeDefaultTeamCompetitionAtom)),
    reportedOrNull(get(homeNextGameAtom)),
    reportedOrNull(get(homeLatestPlayerSearchAtom)),
  ]);

  return { defaultTeam, competition, nextGame, savedSearch: savedSearch ?? undefined };
});
